<template>
  <div class="degree-requirement req">
  <div class="reqinfo">
      <div @click="showSubreqs = !showSubreqs" class="requirement-name">
        {{req.name}}
        <i class="toggle-nested fa fa-caret-right" :class="{'fa-rotate-90': showSubreqs}"></i>
      </div>

      <!-- Satisfy Value -->
      <div class = 'req-item'>
        <template v-if="req.advanced">
          <div class="req-satisfy variable blue">Satisfy {{req.required}} of {{subrequirements}}</div><!--
       --><div class="req-satisfy credits blue">{{req.minimum_credits}} - {{req.maximum_credits}} CR</div>
        </template>
        <template v-else>
          <div class="req-satisfy variable">{{req.minimum_credits}} CR</div><!--
       --><div class="req-satisfy credits">Satisfy {{req.required}} of {{subrequirements}}</div>
        </template>
      </div>
      <div class="clear"></div>
    </div>

    <!-- Subrequirements -->
    <div v-show="showSubreqs" class="subrequirements">
      <requirement
        v-for = 'req in req.subrequirements'
        ref="requirements"
        :req="req"
        :key="req.id"
      >
      </requirement>
    </div>
  </div>
</template>

<script>
  import { sum } from 'lodash'

  export default {
    name: 'degree-requirement',

    // Properties
    // Req - The requirement object
    props: ['req'],

    data() {
      return {
        showSubreqs: true    // Flag to show or hide subrequrements
      }
    },

    mounted() {
      // If the minimum credit hours differ from the minimum credit hours
      // based on subrequirements and satisfy value, then set the variable
      // flag to true
      // let sc = this.computeMinimumCredits()
      // if (sc != this.req.minimum_credits) {
      //   this.variable = true
      // }
    },

    computed: {
      // Number of subrequirements
      subrequirements: function() {
        return this.req.subrequirements.length
      }
    },

    methods: {
      // Set the collapse state of instance requirement and children
      setCollapseState: function(state) {
        this.showSubreqs = state
        this.$refs.requirements.forEach(r => r.setCollapseState(state))
      },

      // used to roll credit count up to parent requirement sets
      computeMinimumCredits() {
        if (this.advanced) {
          return this.req.minimum_credits
        } else if (this.$refs.requirements) {
          const credits = this.$refs.requirements
            .map(req => req.computeMinimumCredits())
            .sort((a, b) => a - b)
          this.req.minimum_credits = this.req.maximum_credits = sum(credits.slice(0, this.req.required))
          return this.req.minimum_credits
        } else {
          this.req.minimum_credits = 0
          return this.req.minimum_credits
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// degree_requirement.vue?058fb2ce